require('./customCardDetails.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ utilities
const { FormattedText } = require('core/i18n').i18n;

class CustomCardDetails extends React.Component {
    buildLoadingSection() {
        return (
            <OKSectionBox className="custom-card-detail">
                <LoadingSection/>
            </OKSectionBox>
        );
    }

    buildCardDetails(immCard) {
        const cardNumber = immCard.get('number');
        const cardType = immCard.get('type');
        const cardTypeValue = `cards-${cardType}`;

        return (
            <OKSectionBox className="custom-card-detail">
                <h1 className="custom-card-detail__title">
                    <FormattedText value="customCardDetails-title"/>
                </h1>
                <CommercialAds path="cards" type="cards" immCard={immCard} />
                <section className="custom-card-detail__field">
                    <h2 className="custom-card-detail__subtitle">
                        <FormattedText value="customCardDetails-cardNumber"/>
                    </h2>
                    <div className="custom-card-detail__value">
                        {cardNumber}
                    </div>
                </section>
                <section className="custom-card-detail__field">
                    <h2 className="custom-card-detail__subtitle">
                        <FormattedText value="customCardDetails-cardType"/>
                    </h2>
                    <div className="custom-card-detail__value">
                        <FormattedText value={cardTypeValue}/>
                    </div>
                </section>
            </OKSectionBox>
        );
    }

    render() {
        const { immCard } = this.props;
        const cardDetailsSection = !immCard ? this.buildLoadingSection() : this.buildCardDetails(immCard);

        return cardDetailsSection;
    }
}

CustomCardDetails.propTypes = {
    immCard: PropTypes.object,
};

module.exports = CustomCardDetails;
